import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function Gracias() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('procesando'); // procesando, confirmado, error
  const ref = searchParams.get('ref');

  useEffect(() => {
    if (!ref) {
      setStatus('error');
      return;
    }

    // Confirmar donación con el backend
    const confirmar = async () => {
      try {
        const { data } = await api.get(`/pagos/confirmar/${ref}`);
        if (data.ok) {
          setStatus('confirmado');
          toast.success('¡Donación confirmada exitosamente! 🐾');
        } else {
          setStatus('error');
        }
      } catch (err) {
        console.error('Error al confirmar pago:', err);
        // Podría ser que el webhook ya lo hizo, así que reintentamos en un momento o mostramos error
        setStatus('error');
      }
    };

    confirmar();
  }, [ref]);

  return (
    <div className="page-wrap fade-up text-center py-16 px-5">
      <div className="card max-w-[500px] mx-auto p-10 md:px-7">
        
        {status === 'procesando' && (
          <>
            <div className="spinner mx-auto mb-5"></div>
            <h2 className="font-fraunces">Validando tu donación...</h2>
            <p className="opacity-70">Estamos verificando tu contribución con la pasarela de pago.</p>
          </>
        )}

        {status === 'confirmado' && (
          <>
            <div className="text-[80px] mb-5">🎁</div>
            <h1 className="font-fraunces text-[32px] mb-2.5 text-v">¡Muchas Gracias!</h1>
            <h3 className="mb-5 opacity-80">Tu apoyo salva vidas.</h3>
            
            <div className="bg-bg p-4 rounded-xl mb-6 border border-dashed border-v">
              <p className="m-0 text-[13px] font-bold text-txs">REFERENCIA DE PAGO</p>
              <p className="m-0 text-lg font-mono font-black">{ref}</p>
            </div>

            <div className="flex flex-col gap-2.5">
              <button className="btn btn-v btn-full btn-lg" onClick={() => navigate('/panel')}>
                Ver mi historial de puntos
              </button>
              <button className="btn btn-ghost btn-full" onClick={() => navigate('/')}>
                Volver al inicio
              </button>
            </div>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="text-[80px] mb-5">🔍</div>
            <h2 className="font-fraunces">Hubo un problema</h2>
            <p className="opacity-70 mb-6">
              No pudimos confirmar tu donación automáticamente. Si el pago se realizó, no te preocupes, el administrador lo validará manualmente.
            </p>
            <div className="bg-red-50 p-4 rounded-xl mb-6 border border-red-200">
              <p className="m-0 text-[13px] font-bold text-red-700">REF: {ref || 'SIN_REFERENCIA'}</p>
            </div>
            <button className="btn btn-full" onClick={() => navigate('/donaciones')}>
                Reintentar o contactar soporte
            </button>
          </>
        )}

      </div>
    </div>
  );
}
